/**
 * Zone Of Kinship (ZOK) Person Type Definitions
 *
 * Core person-related types for the WEPS ecosystem.
 * Unifies PWI and Family & Relationships app type definitions.
 */

import { PersonRelationship, Relationship } from "./relationship.types";

export interface PersonName {
  firstName: string;
  middleName?: string;
  lastName: string;
  nameSuffix?: string;
  title?: string;
  preferredName?: string; // From F&R
}

export interface BeneficiaryReference {
  beneId: string;
  beneSetId: string;
  accountId: string;
}

export interface MemberReferences {
  clientPoid?: string;
  fo5MemberId?: string;
  modelId?: string;
  beneficiaryRefs?: BeneficiaryReference[];
  isTrustSettlor?: boolean; // From F&R
}

export interface LastUpdatedBy {
  id?: string;
  idType?: "CLIENT" | "ASSOCIATE" | "PROCESS";
  correlationCallChain?: string;
  timestamp?: string; // From PWI (keep for backward compatibility)
}

export interface Person {
  householdMemberId: string;
  name: PersonName;
  birthDate: string; // Format: "YYYY-MM-DD"
  referenceIds?: MemberReferences;
  state?: string;
  email?: string;
  isPrimary?: boolean;
  needsReview?: boolean;
  deceased?: boolean;
  relationships?: PersonRelationship[]; // Use F&R's nested structure
  lastUpdatedBy: LastUpdatedBy;
}

export interface PersonWithStatus extends Person {
  status: "created" | "updated" | "unchanged";
}

export function getPersonDisplayName(person: Person): string {
  const preferred = person.name.preferredName?.trim();
  if (preferred) return preferred;
  const first = person.name.firstName.trim();
  const last = person.name.lastName.trim();
  return `${first} ${last}`.trim();
}
